import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "b27511d7-a88a-4b19-b085-17f36b4a8fd5",
    options: { imageDescription: "Cork", imageUrl: `${config.ASSETS_URL}/05/27/task/cork.png` },
  },
  {
    id: "bb6be27c-155d-463e-9fc1-173c8b5541bd",
    options: { imageDescription: "Adobe", imageUrl: `${config.ASSETS_URL}/05/27/task/adobe.png` },
  },
  {
    id: "a3e4cb27-e527-47fd-8fb1-2085b7afb577",
    options: { imageDescription: "Wood", imageUrl: `${config.ASSETS_URL}/05/27/task/wood.png` },
  },
  {
    id: "7fcafe57-7d68-4b2e-99be-2c04917fbce7",
    options: { imageDescription: "Sheep wool", imageUrl: `${config.ASSETS_URL}/05/27/task/sheep-wool.png` },
  },
  {
    id: "0e7cf29f-6107-48f5-9828-89577c35d0c7",
    options: { imageDescription: "Straw", imageUrl: `${config.ASSETS_URL}/05/27/task/straw.png` },
  },
  {
    id: "801b3be8-6a7d-4dc7-b25a-7f3b51def82a",
    options: { imageDescription: "Hemp", imageUrl: `${config.ASSETS_URL}/05/27/task/hemp.png` },
  },
];

const groups = [
  { id: "0b68c8f3-c957-47f1-91e7-7f95e82eaa5e", content: "VIBRATION ISOLATING MATERIALS", options: {} },
  { id: "c0b98d8d-4d68-42fb-9fd0-f37c9d60d511", content: "SOUND ISOLATING MATERIALS", options: {} },
  { id: "cbe7c83e-3ca4-49f5-a7bb-5b3b6c978499", content: "ABSORPTIVE MATERIALS", options: {} },
];

export const task: Task = {
  id: "a7c1c287-abce-4c9b-b996-4207a608bb2b",
  solutionType: "group",
  type: "categorizeImages",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "0b68c8f3-c957-47f1-91e7-7f95e82eaa5e", itemsId: ["b27511d7-a88a-4b19-b085-17f36b4a8fd5"] },
    {
      groupId: "c0b98d8d-4d68-42fb-9fd0-f37c9d60d511",
      itemsId: ["bb6be27c-155d-463e-9fc1-173c8b5541bd", "a3e4cb27-e527-47fd-8fb1-2085b7afb577"],
    },
    {
      groupId: "cbe7c83e-3ca4-49f5-a7bb-5b3b6c978499",
      itemsId: [
        "7fcafe57-7d68-4b2e-99be-2c04917fbce7",
        "0e7cf29f-6107-48f5-9828-89577c35d0c7",
        "801b3be8-6a7d-4dc7-b25a-7f3b51def82a",
      ],
    },
  ],
};
